function handleBadgeDisplay() {
  console.log('Handling badge display');
  const promoText = document.getElementById('badge-text-container');
  const mobilePromoText = document.getElementById('badge-text-container-m');
  if (!promoText && !mobilePromoText) return;
  const checkForPromo = promoText.querySelector('.fs-custom-single-promo');
  const checkForPromoM = mobilePromoText.querySelector('.fs-custom-single-promo');
  console.log('Checking for badge text');
  console.log(checkForPromo);
  console.log(checkForPromoM);
  if (!checkForPromo || !checkForPromoM) {
    console.warn('No badge text found');
    return;
  }
  const allApplicablePromos = promoText.querySelectorAll('.fs-custom-single-promo');
  const allApplicableMobilePromos = mobilePromoText.querySelectorAll('.fs-custom-single-promo');
  let activePromoFound = false;

  const getCurrentUTCTime = () => {
    const now = new Date();
    return now.toISOString();
  };

  const getStartTime = (startTime) => {
    if (!startTime) return null;

    const start = new Date(startTime);
    if (isNaN(start.getTime())) return null;

    return start.toISOString();
  };

  const getEndTime = (endTime) => {
    if (!endTime) return null;

    const end = new Date(endTime);
    if (isNaN(end.getTime())) return null;

    return end.toISOString();
  };

  const isPromoActive = (start, end, persist) => {
    //debugger;
    console.log('Checking if promo is active');
    if (persist == 'true') {
      return true;
    }
    const currentTime = getCurrentUTCTime();
    const startTime = getStartTime(start);
    const endTime = getEndTime(end);

    if (!startTime || !endTime) {
      return false;
    }

    let isActive = currentTime >= startTime && currentTime <= endTime ? true : false;
    return isActive;
  };

  for (let i = 0; i < allApplicablePromos.length; i++) {
    const currPromo = allApplicablePromos[i];
    const currPromoStart = currPromo.getAttribute('data-start-time');
    const currPromoEnd = currPromo.getAttribute('data-end-time');
    const currPromoPersist = currPromo.getAttribute('data-promo-continue');
    const currPromoInAppOnly = currPromo.getAttribute('data-app-only');
    const currPromoNotInApp = currPromo.getAttribute('data-not-in-app');
    const currPromoUtmParams = currPromo.getAttribute('data-utm-params');

    // Get current URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const isInApp = (urlParams.get('app') || '').trim().toLowerCase().startsWith('kinn');

    // Check app-specific conditions
    if (isInApp && currPromoNotInApp === 'true') continue;
    if (!isInApp && currPromoInAppOnly === 'true') continue;

    // Handle UTM parameter validation
    if (currPromoUtmParams) {
      let utmArr = currPromoUtmParams.split(',');
      let hasMatchingUtm = false;

      // Check if any UTM combination matches
      for (let utmCombo of utmArr) {
        const utmPairs = utmCombo.split('&');
        const allPairsMatch = utmPairs.every((pair) => {
          const [key, value] = pair.trim().split('=');
          return urlParams.get(key) === value;
        });

        if (allPairsMatch) {
          hasMatchingUtm = true;
          break;
        }
      }

      if (!hasMatchingUtm) continue;
    }

    if (isPromoActive(currPromoStart, currPromoEnd, currPromoPersist)) {
      console.log('Promo is active');
      activePromoFound = true;

      if (window.innerWidth > 768) {
        allApplicablePromos[i].style.display = 'block';
      } else {
        allApplicableMobilePromos[i].style.display = 'block';
      }

      break;
    }
  }
}

if (document.readyState !== 'loading') {
  handleBadgeDisplay();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    handleBadgeDisplay();
  });
}
